module.exports = __webpack_public_path__ + "img/logo-mbzuai.990c26b9.png";